export function parseDate(input: string, format: string = 'yyyy-mm-dd'): Date {
  const parts = input.match(/(\d+)/g);
  let i = 0;
  const result: {
    yyyy?: number,
    mm?: number,
    dd?: number,
  } = {};
  // extract date-part indexes from the format
  format.replace(/(yyyy|dd|mm)/g, (part: string) => {
    result[part] = +parts[i++];
    return '';
  });

  return new Date(result.yyyy, result.mm - 1, result.dd);
}
